
import { ComponentType } from "react";

// Editor field types
export type EditorFieldType = "text" | "textarea" | "richtext" | "color" | "boolean" | "select" | "number" | "url" | "image" | "icon" | "slider" | "spacing" | "dimensions" | "border" | "shadow" | "collection" | "menu" | "product" | "page" | "array" | "date";

export interface EditorField {
    key: string;
    label: string;
    type: EditorFieldType;
    placeholder?: string;
    description?: string;
    options?: { value: string; label: string }[];
    sliderConfig?: { min: number; max: number; step: number; unit?: string };
    arrayConfig?: {
        itemLabel?: string;
        schema: EditorField[];
    };
    defaultValue?: any;
}

export interface ComponentRegistryEntry {
    category: "layout" | "basic" | "header" | "footer" | "hero" | "product" | "marketing";
    component: ComponentType<Record<string, unknown>>;
    label: string;
    icon: string;
    description: string;
    defaultProps: Record<string, unknown>;
    editorSchema: EditorField[];
}

// ═══════════════════════════════════════════════════════════════
// SHARED FIELDS & ADVANCED CUSTOMIZATION
// ═══════════════════════════════════════════════════════════════

export const ADVANCED_SECTION_FIELDS: EditorField[] = [
    {
        key: "paddingTop",
        label: "مسافة علوية (Padding Top)",
        type: "slider",
        defaultValue: 60,
        sliderConfig: { min: 0, max: 200, step: 4, unit: "px" }
    },
    {
        key: "paddingBottom",
        label: "مسافة سفلية (Padding Bottom)",
        type: "slider",
        defaultValue: 60,
        sliderConfig: { min: 0, max: 200, step: 4, unit: "px" }
    },
    {
        key: "marginTop",
        label: "هامش علوي (Margin Top)",
        type: "slider",
        defaultValue: 0,
        sliderConfig: { min: 0, max: 200, step: 4, unit: "px" }
    },
    {
        key: "marginBottom",
        label: "هامش سفلي (Margin Bottom)",
        type: "slider",
        defaultValue: 0,
        sliderConfig: { min: 0, max: 200, step: 4, unit: "px" }
    },
    {
        key: "container_width",
        label: "عرض المحتوى",
        type: "select",
        options: [
            { value: "default", label: "افتراضي (مقيد)" },
            { value: "wide", label: "عريض (Wide)" },
            { value: "full", label: "كامل الشاشة (Full)" }
        ]
    },
    {
        key: "background_color",
        label: "لون الخلفية (القسم)",
        type: "color"
    }
];

export const SECTION_HEADER_FIELDS: EditorField[] = [
    {
        key: "sectionTitle",
        label: "عنوان القسم (Header)",
        type: "text",
        placeholder: "مثال: وصل حديثاً"
    },
    {
        key: "sectionDescription",
        label: "وصف العنوان",
        type: "textarea",
        placeholder: "وصف قصير يظهر تحت العنوان"
    },
    {
        key: "titleAlignment",
        label: "محاذاة العنوان",
        type: "select",
        options: [
            { value: "right", label: "يمين" },
            { value: "center", label: "وسط" },
            { value: "left", label: "يسار" }
        ]
    }
];
